"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useObjectUrl = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const cache = new WeakMap();
const registry = typeof FinalizationRegistry !== 'undefined'
    ? new FinalizationRegistry((url) => {
        try {
            URL.revokeObjectURL(url);
        }
        catch { }
    })
    : null;
const create = (data, mime) => {
    try {
        const blob = new Blob([data], { type: mime || 'application/octet-stream' });
        return URL.createObjectURL(blob);
    }
    catch {
        return null;
    }
};
const get = (data, mime) => {
    const cached = cache.get(data);
    if (cached)
        return cached;
    const url = create(data, mime);
    if (!url)
        return null;
    cache.set(data, url);
    registry?.register(data, url);
    return url;
};
const useObjectUrl = (data, mime) => React.useMemo(() => (data && data.length ? get(data, mime) : null), [data, mime]);
exports.useObjectUrl = useObjectUrl;
